'use client';

import * as RadioGroupPrimitive from '@radix-ui/react-radio-group';
import * as React from 'react';
import { cn } from '../utils/classnames';

export type RadioGroupProps = React.ComponentPropsWithoutRef<typeof RadioGroupPrimitive.Root>;

const RadioGroup = React.forwardRef<React.ElementRef<typeof RadioGroupPrimitive.Root>, RadioGroupProps>(
  ({ className, ...props }, ref) => {
    return <RadioGroupPrimitive.Root className={cn('grid gap-2', className)} {...props} ref={ref} />;
  }
) as React.ForwardRefExoticComponentExtended<RadioGroupProps>;
RadioGroup.displayName = RadioGroupPrimitive.Root.displayName;

export type RadioGroupItemProps = React.ComponentPropsWithoutRef<typeof RadioGroupPrimitive.Item> & {
  icon?: React.ReactNode;
};

const RadioGroupItem = React.forwardRef<React.ElementRef<typeof RadioGroupPrimitive.Item>, RadioGroupItemProps>(
  ({ className, icon, ...props }, ref) => {
    return (
      <RadioGroupPrimitive.Item
        ref={ref}
        className={cn(
          'border-default-100 text-primary focus-visible:ring-ring aspect-square h-5 w-5 rounded-full border shadow focus:outline-none focus-visible:ring-1 disabled:cursor-not-allowed disabled:opacity-50',
          className
        )}
        {...props}
      >
        {icon ? (
          <RadioGroupPrimitive.Indicator className="flex items-center justify-center">
            {icon}
          </RadioGroupPrimitive.Indicator>
        ) : (
          <RadioGroupPrimitive.Indicator className="relative flex h-full w-full items-center justify-center after:block after:h-[10px] after:w-[10px] after:rounded-[50%] after:bg-white after:content-['']" />
        )}
      </RadioGroupPrimitive.Item>
    );
  }
) as React.ForwardRefExoticComponentExtended<RadioGroupItemProps>;
RadioGroupItem.displayName = RadioGroupPrimitive.Item.displayName;

export { RadioGroup, RadioGroupItem };
